import { useState, useEffect } from "react";
import { adminEmailService, AdminEmail } from "../../services/adminEmailService";

const useAdminEmails = () => {
  const [emails, setEmails] = useState<AdminEmail[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEmails = async () => {
    try {
      setLoading(true);
      const data = await adminEmailService.getAllEmails();
      setEmails(data);
      setError(null);
    } catch (err: any) {
      setError(err.message || "Erreur lors du chargement des emails");
      console.error("Error fetching admin emails:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmails();
  }, []);

  const createEmail = async (name: string, email: string) => {
    try {
      await adminEmailService.createEmail(name, email);
      await fetchEmails(); // Refresh list
    } catch (err: any) {
      throw new Error(err.message || "Erreur lors de la création");
    }
  };

  const updateEmail = async (id: string, name?: string, email?: string) => {
    try {
      await adminEmailService.updateEmail(id, name, email);
      await fetchEmails(); // Refresh list
    } catch (err: any) {
      throw new Error(err.message || "Erreur lors de la mise à jour");
    }
  };

  const updateStatus = async (id: string, status: "ACTIVE" | "INACTIVE") => {
    try {
      await adminEmailService.updateStatus(id, status);
      await fetchEmails(); // Refresh list
    } catch (err: any) {
      throw new Error(err.message || "Erreur lors de la mise à jour du statut");
    }
  };

  const deleteEmail = async (id: string) => {
    try {
      await adminEmailService.deleteEmail(id);
      await fetchEmails(); // Refresh list
    } catch (err: any) {
      throw new Error(err.message || "Erreur lors de la suppression");
    }
  };

  return {
    emails,
    loading,
    error,
    createEmail,
    updateEmail,
    updateStatus,
    deleteEmail,
    refresh: fetchEmails,
  };
};

export default useAdminEmails;
